module.exports = __webpack_public_path__ + "Server-Unavailable.TentaclePassive.56dd53ce83be1488982f11a45b886e83.hashedasset.svg";